import axiosInstance from "@/api/axios";
import { useEffect } from "react";
import {useNavigate} from "react-router-dom";


const LogoutPage = () => {

  const navigate  =  useNavigate();

  useEffect(() => {

    const handleLogout = async () => {
      try {
        // Make the POST request to the logout endpoint
        // Pass null or {} as the data payload (second argument)
        // Pass the config object with withCredentials as the third argument
        await axiosInstance.post("/user/logout", null, { // Or use {} instead of null if needed
          withCredentials: true, // Ensure cookies are sent
        });

        // --- Logout successful ---
        console.log("Logout successful on server.");

      } catch (e) {
        // Log any errors during the API call
        // It's often okay if this fails (e.g., token already expired),
        // but good to log for debugging.
        console.error("Logout API call failed (might be okay):", e.response || e);

      } finally {
        // --- ALWAYS clear client-side auth state regardless of API success ---
        // This ensures the user is logged out on the frontend even if the API fails
        localStorage.removeItem("loggedin");
        console.log("Removed 'loggedin' from localStorage.");

        // --- Redirect using useNavigate ---
        // Replace ensures the logout page isn't in the browser history
        navigate("/login", { replace: true });
      }
    };

    handleLogout();


  }, []);

  return <div></div>;
};

export default LogoutPage;
